import React, { useState, useEffect, useRef } from "react";
import utils from "utils";
import {
  MinusCircleOutlined,
  PlusOutlined,
  LineChartOutlined,
} from "@ant-design/icons";
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  message,
  Select,
  InputNumber,
  Checkbox,
  Card,
} from "antd";
import { useForm } from "antd/lib/form/Form";
import api from "utils/api";
import CommonButton from "Components/CommonButton";
import Loader from "Components/Loader";
import { connect } from "react-redux";
import VitalCharts from "./VitalCharts/VitalCharts";
const VitalFormAdd = (props) => {
  const isbloodGroupChangable = useRef(false);
  const bloodGroupInitialValue = useRef("");
  const [form] = useForm();
  const [formData, setFormData] = useState({});
  const [load, setLoader] = useState(true);
  const [buttonLoad, setButtonLoader] = useState({
    save: false,
    submit: false,
  });
  const [disableSave, setDisableSave] = useState(true);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [latestVitalPresent, setlatestVitalPresent] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const patient_id = props?.patientDetails?.patient_id
    ? props?.patientDetails?.patient_id
    : "";
  useEffect(() => {
    const initialValue = mapFormDataToValues(formData);
    bloodGroupInitialValue.current = initialValue.blood_group;
    form.setFieldsValue({ ...initialValue, others: formData?.others });
  }, [formData]);
  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
    fetchInitialVitalsDoctor(e.target.checked);
  };
  // useEffect(() => {
  //   fetchInitialVitalsDoctor(isChecked);
  // }, [isChecked]);
  function fetchInitialVitals() {
    // const apiCall =
    //   props.user_details?.role == "patient"
    //     ? api.fetch_initial_vitals
    //     : api.fetch_initial_vitals_new;
    const apiCall = api.fetch_initial_vitals;
    apiCall(patient_id)
      .then((response) => {
        if (response.data?.status === 200) {
          setFormData(response.data.data.results[0]);
          setlatestVitalPresent(
            response.data.data.results[0]?.is_latest_vital_present
          );
          // message.success(response.data?.message);
          setLoader(false);
        } else {
          setLoader(false);
          message.error(response.data?.message);
        }
      })
      .catch((err) => {
        setLoader(false);
        message.error("Something went wrong");
      });
  }
  useEffect(() => {
    fetchInitialVitals();
    return () => {
      props.formAction(false);
    };
    // checkDisableSubmit(initialValue);
  }, []);

  const onFinish = (values, key) => {
    const initialValue = mapFormDataToValues(formData);
    let valuesWithoutBloodGroup;
    if (!isbloodGroupChangable.current) {
      // Remove blood_group from values
      let { blood_group, ...tempValuesWithoutBloodGroup } = values;
      valuesWithoutBloodGroup = tempValuesWithoutBloodGroup;

      // Check if other fields are empty
      if (isEmptyCheck(valuesWithoutBloodGroup) && key === "primary") {
        message.error("Please Enter Values");
        return;
      }
    } else {
      // If blood group is changeable, check if it hasn't changed and other fields are empty
      if (values.blood_group === bloodGroupInitialValue.current) {
        let { blood_group, ...tempValuesWithoutBloodGroup } = values;
        valuesWithoutBloodGroup = tempValuesWithoutBloodGroup;

        if (isEmptyCheck(valuesWithoutBloodGroup) && key === "primary") {
          message.error("Please Enter Values");
          return;
        }
      }
    }
    if (
      isEmptyCheck(values) &&
      isEmptyCheck({ ...initialValue, others: formData.others }) &&
      key == "custom"
    ) {
      message.error("Please Enter Values");
      return;
    }
    if (
      isObjectSame(values, { ...initialValue, others: formData.others }) &&
      key === "custom"
    ) {
      message.error("Please Change Values");
      return;
    }
    const requiredVitals = formData?.required_vitals?.map((item) => ({
      value: values[item.field_value],
      field_value: item.field_value,
    }));
    const payload = {
      required_vitals: requiredVitals,
      others: values.others,
      is_saved: true,
      is_submitted: key === "primary",
    };

    const apiCall = key === "primary" ? api.vitals_submit : api.vitals_save;
    setButtonLoader((prev) => ({ ...prev, [key]: true }));
    apiCall({ ...payload, patient_id: patient_id })
      .then((response) => {
        if (response.data?.status === 200) {
          // if (key === "primary") {
          //   form.resetFields();
          // }
          if (props.user_details?.role == "doctor") {
            setDisableSubmit(true);
          }
          message.success(response.data?.message);
          props.formAction(false);
          setIsChecked(false);
          fetchInitialVitals();
        } else {
          message.error(response.data?.message);
        }
      })
      .catch((err) => {
        message.error("Something went wrong");
      })
      .finally(() => {
        setButtonLoader((prev) => ({ ...prev, [key]: false }));
      });
  };
  function isEmptyCheck(values) {
    const isEmpty = Object.values(values).every((value) => {
      if (Array.isArray(value)) {
        return value.length === 0;
      } else {
        return value === "" || value === null;
      }
    });
    return isEmpty;
  }

  function isObjectSame(obj1, obj2) {
    // Check if both objects have the same keys
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
      return false;
    }

    // Check if all properties have the same values
    return keys1.every((key) => {
      const value1 = obj1[key];
      const value2 = obj2[key];

      // If the value is an array, compare each element
      if (Array.isArray(value1) && Array.isArray(value2)) {
        if (value1.length !== value2.length) {
          return false;
        }
        return value1.every((item, index) => {
          return isObjectSame(item, value2[index]);
        });
      }

      // Compare non-array values
      return value1 === value2;
    });
  }
  function checkDisableSave(values) {
    if (isEmptyCheck(values)) {
      setDisableSave(true);
    } else {
      form
        .validateFields()
        .then(() => {
          setDisableSave(false);
        })
        .catch(() => {
          setDisableSave(true);
        });
    }
  }
  function checkDisableSubmit(values) {
    if (isEmptyCheck(values)) {
      setDisableSubmit(true);
    } else {
      form
        .validateFields()
        .then(() => {
          setDisableSubmit(false);
        })
        .catch(() => {
          setDisableSubmit(true);
        });
    }
  }
  function handleFieldsChange() {
    const values = form.getFieldsValue();
    checkDisableSave(values);
    checkDisableSubmit(values);
  }
  function mapFormDataToValues(formData) {
    if (!formData) return {};

    const values = {};
    formData?.required_vitals?.forEach((item) => {
      values[item.field_value] = item.value;
    });
    return values;
  }
  function onSaveFinish(values, key) {
    form
      .validateFields()
      .then(() => {
        onFinish(values, key);
      })
      .catch(() => {
        // setDisableSubmit(true);
      });
  }
  const calculateBMI = (height1, weight1) => {
    const height = parseFloat(height1) || 0;
    const weight = parseFloat(weight1) || 0;
    const heightobj = formData?.required_vitals.find(
      (item) => item.field_value === "height"
    );
    const weightobj = formData?.required_vitals.find(
      (item) => item.field_value === "weight"
    );
    if (!height || !weight || height === 0 || weight === 0) {
      return "";
    }
    if (
      height >= heightobj?.min &&
      height <= heightobj?.max &&
      weight >= weightobj?.min &&
      weight <= weightobj?.max
    ) {
      const heightInMeters = height / 100; // Convert height to meters
      return (weight / (heightInMeters * heightInMeters)).toFixed(2);
    } else {
      return "";
    }
  };
  const handleFormChange = (fieldName, value) => {
    // form.setFieldsValue({ [fieldName]: value });
    if (fieldName === "height" || fieldName === "weight") {
      const height =
        fieldName === "height" ? value : form.getFieldValue("height");
      const weight =
        fieldName === "weight" ? value : form.getFieldValue("weight");
      const bmi = calculateBMI(height, form.getFieldValue("weight"));
      form.setFieldsValue({ bmi: bmi });
    }
  };
  const renderFormItem = (item) => {
    const disable = !item?.is_changeable;
    switch (item.field_value) {
      case "blood_group":
        isbloodGroupChangable.current = item?.is_changeable;
        return (
          <Form.Item
            name={item.field_value}
            label={item.label}
            // rules={[{ required: true, message: `Please select ${item.label}` }]}
          >
            <Select
              placeholder={`Select ${item.label}`}
              // onChange={(value) =>
              //   handleFormChange(item.field_value, value)
              // }
              disabled={disable}
            >
              {item.choices.map((choice) => (
                <Select.Option key={choice} value={choice}>
                  {choice}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        );
      case "blood_pressure":
        return (
          <Form.Item
            name={item.field_value}
            label={item.label}
            // validateTrigger={["onBlur"]}
            rules={[
              {
                validator: (_, value) => {
                  if (!value) {
                    return Promise.resolve();
                  }
                  if (/^\d+\/\d+$/.test(value)) {
                    const [systolicPressure, diastolicPressure] = value
                      .split("/")
                      .map(Number);
                    const [systolicPressureMin, diastolicPressureMin] = item.min
                      .split("/")
                      .map(Number);
                    const [systolicPressureMax, diastolicPressureMax] = item.max
                      .split("/")
                      .map(Number);

                    if (
                      systolicPressure >= systolicPressureMin &&
                      systolicPressure <= systolicPressureMax &&
                      diastolicPressure >= diastolicPressureMin &&
                      diastolicPressure <= diastolicPressureMax
                    ) {
                      return Promise.resolve();
                    } else {
                      return Promise.reject(
                        `Value must be between ${item.min}${item.unit} and ${item.max}${item.unit}`
                      );
                      return Promise.reject(
                        "Systolic pressure must be between " +
                          systolicPressureMin +
                          " and " +
                          systolicPressureMax +
                          ", and diastolic pressure must be between " +
                          diastolicPressureMin +
                          " and " +
                          diastolicPressureMax
                      );
                    }
                  } else {
                    return Promise.reject(`Please enter a valid input`);
                  }
                },
              },
            ]}
          >
            <Input
              placeholder={`Enter ${item.label}`}
              suffix={item.unit}
              disabled={disable}

              // onChange={(e) =>
              //   handleFormChange(item.field_value, e.target.value)
              // }
            />
          </Form.Item>
        );
      default:
        return (
          <Form.Item
            name={item.field_value}
            label={item.label}
            rules={[
              // {
              //   required: true,
              //   message: `Please enter ${item.label}`
              // },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  // console.log(value, parseFloat(value));
                  if (!value) {
                    return Promise.resolve();
                  }
                  if (/^\d+(\.\d{1,3})?$/.test(value) && !/\.$/.test(value)) {
                    if (
                      parseFloat(value) >= item.min &&
                      parseFloat(value) <= item.max
                    ) {
                      return Promise.resolve();
                    } else {
                      return Promise.reject(
                        `Value must be between ${item.min}${item.unit} and ${item.max}${item.unit}`
                      );
                    }
                  } else {
                    return Promise.reject("Please Enter a Valid Input");
                  }
                },
              }),
            ]}
            // validateTrigger={["onBlur"]}
          >
            <Input
              // style={{ width: "100%" }}
              placeholder={`Enter ${item.label}`}
              suffix={item.unit}
              disabled={disable}
              onChange={(value) => handleFormChange(item.field_value, value)}
              // max={item.max}
              // min={item.min}
            />
          </Form.Item>
        );
    }
  };
  function fetchInitialVitalsDoctor(check) {
    if (check) {
      api
        .fetch_initial_vitals(patient_id)
        .then((response) => {
          if (response.data?.status === 200) {
            setFormData(response.data.data.results[0]);
            message.success("Patient Vital values AutoFilled Successfully");
            setLoader(false);
          } else {
            setLoader(false);
            message.error(response.data?.message);
          }
        })
        .catch((err) => {
          setLoader(false);
          message.error("Something went wrong");
        });
    } else {
      fetchInitialVitals();
    }
  }
  return (
    <>
      {load ? (
        <Loader />
      ) : (
        <div>
          {/* <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              paddingBottom: "10px",
            }}
          >
            <div
              style={{
                color: "var(--background-color)",
                cursor: "pointer",
                fontSize: "16px",
              }}
              onClick={() => {
                utils.Modal(true, {
                  content: (
                    <Card title="Evaluation Charts">
                      <VitalCharts patientDetails={props?.patientDetails} />
                    </Card>
                  ),

                  width: "90vw",
                });
              }}
            >
              <LineChartOutlined />
              <span> Show Evaluation Chart</span>
            </div>
          </div> */}
          {/* {props.user_details?.role !== "patient" && (
            // <Row align="middle" style={{paddingBottom:"10px"}}>
            //   <Col>
            <>
              {latestVitalPresent ? (
                <Checkbox onChange={handleCheckboxChange} checked={isChecked}>
                  AutoFill the most recent Patient Vitals
                </Checkbox>
              ) : (
                <p style={{ color: "red" }}>
                  The Patient has not provided any Vitals.
                </p>
              )}
            </>
            //   </Col>
            // </Row>
          )} */}
          <Form
            form={form}
            name="vital-form"
            // initialValues={initialValue}
            onFinish={(values) => onFinish(values, "primary")}
            labelCol={{ span: 12, offset: 0 }}
            wrapperCol={{ span: 12, offset: 0 }}
            labelAlign="left"
            autoComplete="off"
            // onFieldsChange={() => {
            //   handleFieldsChange();
            // }}
            // validateTrigger={["onBlur"]}
            onFieldsChange={() => props.formAction(true)}
            colon={false}
          >
            {" "}
            <Row gutter={4}>
              <Col  xs={24} md={24} lg={12} xl={12}>
                <Row span={24} gutter={4}>
                  {formData?.required_vitals?.map((item) => (
                    <Col span={24} key={item.field_value}>
                      {renderFormItem(item)}
                    </Col>
                  ))}
                </Row>
              </Col>
              <Col xs={24} md={24} lg={12} xl={12}>
                <Row gutter={4}>
                  <Col span={24}>
                    <Form.List
                      name="others"
                      //  initialValue={formData.others}
                    >
                      {(fields, { add, remove }) => (
                        <>
                          {fields.map(({ key, name, ...restField }) => (
                            <Row key={key} span={24} gutter={4} align="top">
                              <Col span={9}>
                                <Form.Item
                                  wrapperCol={{ span: 24 }}
                                  {...restField}
                                  name={[name, "label"]}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Missing Label",
                                    },
                                    {
                                      pattern:
                                        /^[A-Za-z0-9]+(?:\s*[A-Za-z0-9]+)*$/,
                                      message: "Please enter valid input",
                                    },
                                  ]}
                                  // style={{ marginRight: 8 }}
                                >
                                  <Input placeholder="Enter Label" />
                                </Form.Item>
                              </Col>
                              <Col span={8}>
                                <Form.Item
                                  wrapperCol={{ span: 24 }}
                                  {...restField}
                                  name={[name, "value"]}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Missing Value",
                                    },
                                  ]}
                                  // style={{ marginRight: 8 }}
                                >
                                  <Input placeholder="Enter Value" />
                                </Form.Item>
                              </Col>
                              <Col span={5}>
                                <Form.Item
                                  wrapperCol={{ span: 24 }}
                                  {...restField}
                                  name={[name, "unit"]}
                                  // rules={[
                                  //   { required: true, message: "Missing Unit" },
                                  // ]}
                                  // style={{ marginRight: 8 }}
                                >
                                  <Input placeholder="Enter Unit" />
                                </Form.Item>{" "}
                              </Col>{" "}
                              <Col span={2}>
                              <Form.Item>
                                <MinusCircleOutlined
                                  onClick={() => remove(name)}
                                />
                                </Form.Item>
                              </Col>
                            </Row>
                          ))}
                          <Form.Item wrapperCol={{ span: 24 }}>
                            <Button
                              type="dashed"
                              onClick={() => add()}
                              block
                              icon={<PlusOutlined />}
                              disabled={fields.length > 7}
                            >
                              Add New Vital fields
                            </Button>
                          </Form.Item>
                        </>
                      )}
                    </Form.List>
                  </Col>
                </Row>
              </Col>
            </Row>
            {/* <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
              <CommonButton
                loading={buttonLoad.submit}
                className="common-button-green"
                htmlType="submit"
                label="Submit"
              >
                Submit
              </CommonButton>
              <CommonButton
                loading={buttonLoad.save}
                onClick={() => onSaveFinish(form.getFieldsValue(), "custom")}
                style={{ marginLeft: 8 }}
                label="Save"
                className="common-button-white"
              ></CommonButton>
            </Form.Item> */}
            <Form.Item
              wrapperCol={{ offset: 0, span: 0 }}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  flexWrap: "wrap",
                  gap: "8px",
                }}
              >
                {/* {props.user_details?.role == "patient" && ( */}
                <CommonButton
                  loading={buttonLoad.save}
                  onClick={() => onSaveFinish(form.getFieldsValue(), "custom")}
                  // style={{ marginLeft: 8 }}
                  label="Save"
                  className="common-button-white"
                  disabled={!formData?.is_vital_eligible}
                ></CommonButton>
                {/* )} */}
                {/* {patient_id ? (
                  ""
                ) : ( */}
                <CommonButton
                  loading={buttonLoad.submit}
                  className="common-button-green"
                  // htmlType="submit"
                  label="Submit"
                  style={{ marginLeft: 8 }}
                  // disabled={disableSubmit}
                  // disabled={disableSubmit||!formData?.is_vital_eligible}
                  disabled={!formData?.is_vital_eligible}
                  onClick={() => onSaveFinish(form.getFieldsValue(), "primary")}
                >
                  Submit
                </CommonButton>
                {/* )} */}
              </div>
              {/* {patient_id ? (
                ""
              ) : ( */}
              {props.user_details?.role == "patient" && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <p style={{ color: "red" }}>
                    Once Vital form submitted, it cannot be edited
                  </p>
                </div>
              )}
              {/* )} */}
            </Form.Item>
          </Form>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user_details: state.loginReducer?.user_details,
    patient_id: state.patientDetailReducer.patient_detail,
  };
};
export default connect(mapStateToProps)(VitalFormAdd);
